import {HistoricalOptionRecord} from "../../../price/historical/HistoricalPriceModels";

export class HistoricalOption {

    private constructor(public readonly record: HistoricalOptionRecord,
                        public readonly inTheMoney: boolean,
                        public readonly selected: boolean) {
    }

    public static create(record: HistoricalOptionRecord, inTheMoney: boolean, selected: boolean): HistoricalOption {
        return new HistoricalOption(record, inTheMoney, selected);
    }

    public static empty(): HistoricalOption {
        const record = {} as HistoricalOptionRecord;
        return new HistoricalOption(record, false, false);
    }
}
